import { graphDataNode, graphDataStyle, graphDefault, graphNodeGroupOpen } from './';
export const graphTargetNode = (theme, parameters) => {
  const styleDefault = graphDataStyle.styleDefault(theme, parameters);
  const dataNode1 = graphDataNode.node1(theme, parameters);
  const defaultPattern = graphDefault(theme, parameters);
  const common = {
    fillColor: dataNode1.fillColor,
    lineColor: dataNode1.lineColor,
    lineStyle: styleDefault.lineStyle
  };
  switch (theme.baseThemeName) {
    case 'dark':
      {
        return {
          ...common,
          textColor: dataNode1.textColor,
          lineThickness: 2
        };
      }
    case 'high-contrast':
      {
        return {
          ...common,
          fillColor: defaultPattern.n_3,
          lineThickness: 3,
          textColor: graphNodeGroupOpen(theme, parameters).textColor
        };
      }
    default:
      {
        return {
          ...common,
          textColor: dataNode1.textColor,
          lineThickness: 1
        };
      }
  }
};
//# sourceMappingURL=graphTargetNode.js.map